"use strict";

/*
    Vanilla AutoComplete v0.1
    Copyright (c) 2019 Mauro Marssola
    GitHub: https://github.com/marssola/vanilla-calendar
    License: http://www.opensource.org/licenses/mit-license.php
*/

var VanillaCalendar = function () {
  function VanillaCalendar(options) {
    function addEvent(el, type, handler) {
      if (!el) return;
      if (el.attachEvent) el.attachEvent('on' + type, handler);else el.addEventListener(type, handler);
    }
    function removeEvent(el, type, handler) {
      if (!el) return;
      if (el.detachEvent) el.detachEvent('on' + type, handler);else el.removeEventListener(type, handler);
    }
    var opts = {
      selector: null,
      datesFilter: false,
      pastDates: true,
      availableWeekDays: [],
      availableDates: [],
      date: new Date(),
      todaysDate: new Date(),
      button_prev: null,
      button_next: null,
      month: null,
      month_label: null,
      onSelect: function onSelect(data, elem) {},
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      shortWeekday: ['SU', 'M', 'T', 'W', 'TH', 'F', 'S']
    };
    for (var k in options) if (opts.hasOwnProperty(k)) opts[k] = options[k];
    var element = document.querySelector(opts.selector);
    if (!element) return;
    var getWeekDay = function getWeekDay(day) {
      return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][day];
    };
    var createDay = function createDay(date) {
      var newDayElem = document.createElement('div');
      var dateElem = document.createElement('span');
      dateElem.innerHTML = date.getDate();
      newDayElem.className = 'vanilla-calendar-date';
      newDayElem.setAttribute('data-calendar-date', date);
      var available_week_day = opts.availableWeekDays.filter(function (f) {
        return f.day === date.getDay() || f.day === getWeekDay(date.getDay());
      });
      var available_date = opts.availableDates.filter(function (f) {
        return f.date === date.getFullYear() + '-' + String(date.getMonth() + 1).padStart('2', 0) + '-' + String(date.getDate()).padStart('2', 0);
      });
      if (date.getDate() === 1) {
        newDayElem.style.marginLeft = date.getDay() * 14.28 + '%';
      }
      if (opts.date.getTime() <= opts.todaysDate.getTime() - 1 && !opts.pastDates) {
        newDayElem.classList.add('vanilla-calendar-date--disabled');
      } else {
        if (opts.datesFilter) {
          if (available_week_day.length) {
            newDayElem.classList.add('vanilla-calendar-date--active');
            newDayElem.setAttribute('data-calendar-data', JSON.stringify(available_week_day[0]));
            newDayElem.setAttribute('data-calendar-status', 'active');
          } else if (available_date.length) {
            newDayElem.classList.add('vanilla-calendar-date--active');
            newDayElem.setAttribute('data-calendar-data', JSON.stringify(available_date[0]));
            newDayElem.setAttribute('data-calendar-status', 'active');
          } else {
            newDayElem.classList.add('vanilla-calendar-date--disabled');
          }
        } else {
          newDayElem.classList.add('vanilla-calendar-date--active');
          newDayElem.setAttribute('data-calendar-status', 'active');
        }
      }
      if (date.toString() === opts.todaysDate.toString()) {
        newDayElem.classList.add('vanilla-calendar-date--today');
      }
      newDayElem.appendChild(dateElem);
      opts.month.appendChild(newDayElem);
    };
    var removeActiveClass = function removeActiveClass() {
      var selected = Array.prototype.slice.call(document.querySelectorAll('.vanilla-calendar-date--selected'));
      selected.forEach(function (s) {
        s.classList.remove('vanilla-calendar-date--selected');
      });
    };
    var selectDate = function selectDate() {
      var activeDates = Array.prototype.slice.call(element.querySelectorAll('[data-calendar-status=active]'));
      if (activeDates && activeDates.length > 0) {
        activeDates.forEach(function (date) {
          date.addEventListener('click', function () {
            removeActiveClass();
            var datas = this.dataset;
            var data = {};
            if (datas.calendarDate) data.date = datas.calendarDate;
            if (datas.calendarData) data.data = JSON.parse(datas.calendarData);
            opts.onSelect(data, this);
            this.classList.add('vanilla-calendar-date--selected');
          });
        });
      }
    };
    var createMonth = function createMonth() {
      clearCalendar();
      var currentMonth = opts.date.getMonth();
      while (opts.date.getMonth() === currentMonth) {
        createDay(opts.date);
        opts.date.setDate(opts.date.getDate() + 1);
      }
      opts.date.setDate(1);
      opts.date.setMonth(opts.date.getMonth() - 1);
      opts.month_label.innerHTML = opts.months[opts.date.getMonth()] + ' ' + opts.date.getFullYear();
      selectDate();
    };
    var monthPrev = function monthPrev() {
      opts.date.setMonth(opts.date.getMonth() - 1);
      createMonth();
    };
    var monthNext = function monthNext() {
      opts.date.setMonth(opts.date.getMonth() + 1);
      createMonth();
    };
    var clearCalendar = function clearCalendar() {
      opts.month.innerHTML = '';
    };
    var createCalendar = function createCalendar() {
      document.querySelector(opts.selector).innerHTML = "<div class='vanilla-calendar-header'>" + "<button type='button' class='vanilla-calendar-btn' data-calendar-toggle='previous'>" + "<svg xmlns='http://www.w3.org/2000/svg' aria-hidden='true' focusable='false' data-prefix='fas' data-icon='chevron-left' class='svg-inline--fa fa-chevron-left fa-w-10' role='img' viewBox='0 0 320 512'><path fill='#00a9e0' d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'/></svg>" + "</button>" + "<div class='vanilla-calendar-header__label' data-calendar-label='month'></div>" + "<button type='button' class='vanilla-calendar-btn' data-calendar-toggle='next'><svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='chevron-right' class='svg-inline--fa fa-chevron-right fa-w-10' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'><path fill='#00a9e0' d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'></path></svg></button>" + "</div>" + "<div class='vanilla-calendar-week'></div>" + "<div class='vanilla-calendar-body' data-calendar-area='month'></div>";
    };
    var setWeekDayHeader = function setWeekDayHeader() {
      document.querySelector(opts.selector + ' .vanilla-calendar-week').innerHTML = "<span>" + opts.shortWeekday[0] + "</span>" + "<span>" + opts.shortWeekday[1] + "</span>" + "<span>" + opts.shortWeekday[2] + "</span>" + "<span>" + opts.shortWeekday[3] + "</span>" + "<span>" + opts.shortWeekday[4] + "</span>" + "<span>" + opts.shortWeekday[5] + "</span>" + "<span>" + opts.shortWeekday[6] + "</span>";
    };
    this.init = function () {
      createCalendar();
      opts.button_prev = document.querySelector(opts.selector + ' [data-calendar-toggle=previous]');
      opts.button_next = document.querySelector(opts.selector + ' [data-calendar-toggle=next]');
      opts.month = document.querySelector(opts.selector + ' [data-calendar-area=month]');
      opts.month_label = document.querySelector(opts.selector + ' [data-calendar-label=month]');
      opts.date.setDate(1);
      createMonth();
      setWeekDayHeader();
      addEvent(opts.button_prev, 'click', monthPrev);
      addEvent(opts.button_next, 'click', monthNext);
    };
    this.destroy = function () {
      removeEvent(opts.button_prev, 'click', monthPrev);
      removeEvent(opts.button_next, 'click', monthNext);
      clearCalendar();
      document.querySelector(opts.selector).innerHTML = '';
    };
    this.reset = function () {
      this.destroy();
      this.init();
    };
    this.set = function (options) {
      for (var _k in options) if (opts.hasOwnProperty(_k)) opts[_k] = options[_k];
      createMonth();
      //             this.reset()
    };
    this.init();
  }
  return VanillaCalendar;
}();

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length > targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}
window.VanillaCalendar = VanillaCalendar;